import {
  SpoPosterTableResponseItemSmSegmentationNeedColumnsItem,
  SpoPosterTableResponseItemSmSegmentationNeedColumnsItemNeedSegmentationSmColumnsItem,
} from '@spo/types';
import clsx from 'clsx';
import { ThirdLevel } from '../ThirdLevel';
import './secondLevel.scss';

export const SecondLevel = ({
  content,
}: {
  content: SpoPosterTableResponseItemSmSegmentationNeedColumnsItem;
}) => (
  <div
    className={clsx('second-level', {
      'one-child': content.needSegmentation.smColumns.length === 1,
    })}
    data-testid="second-level"
  >
    <div className="second-level-labels">
      <div className="second-level-label" data-testid="second-level_label">
        {content.needSegmentation.id} - {content.needSegmentation.label}
      </div>
      <div className="second-level-sub-label">
        {content.needSegmentation.usageSegmentationLabel ?? '-'}
      </div>
    </div>
    <div className="third-levels-container">
      {content.needSegmentation.smColumns.map(
        (
          smColumns: SpoPosterTableResponseItemSmSegmentationNeedColumnsItemNeedSegmentationSmColumnsItem,
        ) => (
          <ThirdLevel key={smColumns.smCard.id} content={smColumns} />
        ),
      )}
    </div>
  </div>
);
